import { FC, useEffect } from "react";

import { ThreediModel } from "@nens/threedi/openapi-client";

import { taskIsFinished, useModelTasks } from "../../queries/threedimodels";

import TasksTable from "./TasksTable";

interface ModelTasksInProgressProps {
  callbackWhenAllFinished: () => void;
  model: ThreediModel;
}

// Model with isValid null; show status of ongoing tasks.

const ModelTasksInProgress: FC<ModelTasksInProgressProps> = ({
  callbackWhenAllFinished,
  model,
}) => {
  const tasksResponse = useModelTasks(model.id);
  const allFinished = tasksResponse.isSuccess
    ? tasksResponse.data.results.every(taskIsFinished)
    : false;

  // When all are finished, call callback so page can change
  useEffect(() => {
    if (allFinished) {
      callbackWhenAllFinished();
    }
  }, [allFinished, callbackWhenAllFinished]);

  return (
    <>
      <p>A Rana model of this revision is being generated.</p>
      {tasksResponse.isSuccess ? <TasksTable tasks={tasksResponse.data.results} /> : null}
    </>
  );
};

export default ModelTasksInProgress;
